import { useEffect } from "react";

const APP_PAYLIST_DEEPLINK =
  (import.meta.env.VITE_APP_PAYLIST_DEEPLINK as string | undefined)?.trim() ||
  "julyupay://pay";

function isMobileUa() {
  if (typeof window === "undefined") return false;
  const ua = window.navigator.userAgent || "";
  return /Android|iPhone|iPad|iPod/i.test(ua);
}

export default function PaylistEntry() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const fallback = () => window.location.replace("/pay");

    if (!isMobileUa()) {
      fallback();
      return;
    }

    let hidden = false;
    const onVisibility = () => {
      if (document.visibilityState === "hidden") hidden = true;
    };
    document.addEventListener("visibilitychange", onVisibility);

    const t = window.setTimeout(() => {
      document.removeEventListener("visibilitychange", onVisibility);
      if (!hidden) fallback();
    }, 1200);

    window.location.href = APP_PAYLIST_DEEPLINK;

    return () => {
      window.clearTimeout(t);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);

  return null;
}
